import { z } from 'zod';
import { Platform } from '../enums.js';
import { emailSchema } from './email.js';

export const signInSchema = z.object({
  email: emailSchema(),
  password: z.string().min(1),
  platform: z.enum(Platform).optional(),
});

export type SignInPayload = z.infer<typeof signInSchema>;
